import React from 'react';
import brands from '../../data/ourBrands.json'; // Importamos el JSON
import '../../styles/Home.css';

const OurBrands = () => {
    return (
        <section className="our-brands-section" id='our-brands'>
            <div className='container'>
                {/* Título */}
                <div className="title-container mt-5" data-aos="fade-up" data-aos-offset="50">
                    <h2 className="title">Nuestras Marcas</h2>
                    <div className="title-underline"></div>
                </div>

                <div className='row'>
                    <div className='col-lg-6 col-md-12 d-flex align-items-center' data-aos="flip-left">
                        <div className='our-brands-description p-4'>
                            <p>
                                Creamos una red de marcas especializadas, cada una diseñada para responder a necesidades y
                                demandas específicas de nuestro público. Desde la creación de contenido educativo y multimedia,
                                sobre servicios de salud y tecnología, nuestras marcas trabajan juntas para conectar, educar e inspirar,
                                fortaleciendo la presencia digital de BeHealth y, por sobre todas las cosas, generando impacto positivo.
                            </p>
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-12'>
                        <div className='row our-brands-row'>
                            {brands.map((brand, index) => (
                                <div key={index} className='col-md-4 col-6 mt-2' data-aos="zoom-out">
                                    <img src={brand.src} className='img-fluid our-brands-img shadow' alt={brand.alt} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurBrands;
